module.exports = __webpack_public_path__ + "static/media/zoom-in.48250973.svg";